module.exports = __webpack_public_path__ + "static/media/SDG1.d38b90d3.mp4";